// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__iEe1F","loader":"styles_loader__M++ma","spin":"styles_spin__MwsFO"};